import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, type Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  // Signal-based approach for modern Angular
  private loadingSignal = signal<boolean>(false);
  private messageSignal = signal<string>('Loading...');

  // Observable approach for compatibility
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private messageSubject = new BehaviorSubject<string>('Loading...');

  // Public signals
  readonly isLoading = this.loadingSignal.asReadonly();
  readonly loadingMessage = this.messageSignal.asReadonly();

  // Public observables
  readonly loading$: Observable<boolean> = this.loadingSubject.asObservable();
  readonly message$: Observable<string> = this.messageSubject.asObservable();

  /**
   * Show the global loader
   * @param message Optional custom loading message
   */
  show(message = 'Loading...'): void {
    this.loadingSignal.set(true);
    this.messageSignal.set(message);
    this.loadingSubject.next(true);
    this.messageSubject.next(message);
  }

  /**
   * Hide the global loader
   */
  hide(): void {
    this.loadingSignal.set(false);
    this.loadingSubject.next(false);
  }

  /**
   * Update the loading message without changing loading state
   * @param message New loading message
   */
  updateMessage(message: string): void {
    this.messageSignal.set(message);
    this.messageSubject.next(message);
  }

  /**
   * Check if loader is currently active
   */
  isActive(): boolean {
    return this.loadingSignal();
  }
}
